import { POIs as P } from "@local-logic/client";
import { POIList, ScorePOIs } from "@local-logic/elements-react";
import { UseQueryResult } from "@tanstack/react-query";
import React, { useContext } from "react";
import { GoogleMapContext } from "~/sdks/LocalContent/Map/GoogleMap/context";
import { useLocalContent } from "~/sdks/LocalContent/context";
import { getCenterWithOffset } from "~/utils/formatters/getCenterWithOffset";

const GooglePOI = React.memo(
  ({ result, poi }: { result: UseQueryResult<P, unknown>; poi: keyof P }) => {
    const { activePOI, setActivePOI, hoveredPOI, setHoveredPOI } =
      useLocalContent();
    const { googleMapRef } = useContext(GoogleMapContext);

    if (!result.data?.[poi]) {
      return null;
    }

    return (
      <ScorePOIs.Content key={poi} options={{ value: poi }}>
        <POIList.Root
          options={{
            type: "poi",
            data: result.data[poi],
            activePOI,
            hoveredPOI,
          }}
          onChange={(e) => {
            if (e.type === "poi-click") {
              const p = e.data;
              setActivePOI(p);

              if (p && googleMapRef) {
                googleMapRef.setZoom(20);

                const newCenter = getCenterWithOffset({
                  map: googleMapRef,
                  lat: p.lat,
                  lng: p.lng,
                  xPixelOffset: 190,
                  yPixelOffset: 0,
                });

                if (newCenter) googleMapRef.setCenter(newCenter);
              }
            }

            if (e.type === "poi-hover") {
              setHoveredPOI(e.data);
            }
          }}
        />
      </ScorePOIs.Content>
    );
  }
);

GooglePOI.displayName = "POI";

export default GooglePOI;
